import React, { useState, useEffect } from "react";
import styles from "./Hero.module.css";

function Hero() {
  const [days, setDays] = useState(0);

  useEffect(() => {
    const startDate = new Date("2021-04-01");
    const now = new Date();
    const diff = Math.floor((now - startDate) / (1000 * 60 * 60 * 24));
    setDays(diff);
  }, []);

  return (
    <section className={styles.section} style={{ opacity: 0, animation: "fadeIn 0.6s ease-out 0.1s forwards" }}>
      <p className={styles.dayCount}>
        i've been building things for{" "}
        <span className={styles.days}>{days.toLocaleString()}</span> days.
      </p>
      <p className={styles.tagline}>
        former chef who traded the kitchen for code during covid.{" "}
        <span className={styles.panWrap}>
          <span className={styles.bacon}>🥓</span>
          <span className={styles.pan}>🍳</span>
        </span>{" "}
        now an ai builder obsessed with agent orchestration, autonomous workflows & shipping products that think for themselves.
      </p>
    </section>
  );
}

export default Hero;
